import { Injectable } from '@angular/core';
import { UserWizardService } from '../../../services/user/user.wizard.service';
import { ApiService, InputDatastoreService, CountryListService, DialogService, UserService, ValuesExchangeProvider } from '@nrwl/common-lib';

@Injectable()
export class ApplicationEmailWizardService extends UserWizardService {
  selectedApps = [];
  requestObject: any;
  selectedUserName = '';

  constructor(apiService: ApiService,
    inputDatastoreService: InputDatastoreService,
    countryListService: CountryListService,
    dialogService: DialogService,
    readonly userService: UserService,
    valuesExchange: ValuesExchangeProvider) {
    super(apiService, inputDatastoreService, countryListService, dialogService, userService, valuesExchange);
  }
}
